import React from "react";
import { Plus, Trash2 } from "lucide-react";
import AiPromptGenerator from "@/components/resume-builder/AiPromptGenerator";

const FIELD_CLASS = "bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400";
const EMPTY_ENTRY = { school: "", degree: "", field: "", start_date: "", end_date: "" };

export default function EducationSection({ draft, setDraft }) {
  const updateEntry = (idx, field, value) => setDraft({ ...draft, education: draft.education.map((e, i) => (i === idx ? { ...e, [field]: value } : e)) });
  const removeEntry = (idx) => setDraft({ ...draft, education: draft.education.filter((_, i) => i !== idx) });
  const addEntry = () => setDraft({ ...draft, education: [...draft.education, { ...EMPTY_ENTRY }] });

  return (
    <div className="glass-panel rounded-2xl p-5" data-testid="resume-section-education">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold text-white">Education</p>
        <button onClick={addEntry} data-testid="resume-add-education-button" className="flex items-center gap-1 text-xs font-semibold text-indigo-300 hover:text-indigo-200">
          <Plus className="w-3.5 h-3.5" /> Add Education
        </button>
      </div>
      <div className="space-y-3 mb-3">
        {draft.education.map((entry, idx) => (
          <div key={idx} className="bg-white/[0.03] rounded-xl p-4" data-testid={`resume-education-entry-${idx}`}>
            <div className="flex justify-end mb-2">
              <button onClick={() => removeEntry(idx)} data-testid={`resume-remove-education-${idx}`} className="text-slate-400 hover:text-red-400"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <input value={entry.school} onChange={(e) => updateEntry(idx, "school", e.target.value)} placeholder="School / University" data-testid={`resume-education-school-${idx}`} className={FIELD_CLASS} />
              <input value={entry.degree} onChange={(e) => updateEntry(idx, "degree", e.target.value)} placeholder="Degree" data-testid={`resume-education-degree-${idx}`} className={FIELD_CLASS} />
              <input value={entry.field} onChange={(e) => updateEntry(idx, "field", e.target.value)} placeholder="Field of Study" data-testid={`resume-education-field-${idx}`} className={FIELD_CLASS} />
              <div className="flex gap-2">
                <input value={entry.start_date} onChange={(e) => updateEntry(idx, "start_date", e.target.value)} placeholder="Start" data-testid={`resume-education-start-${idx}`} className={FIELD_CLASS + " flex-1"} />
                <input value={entry.end_date} onChange={(e) => updateEntry(idx, "end_date", e.target.value)} placeholder="End" data-testid={`resume-education-end-${idx}`} className={FIELD_CLASS + " flex-1"} />
              </div>
            </div>
          </div>
        ))}
        {draft.education.length === 0 && <p className="text-xs text-slate-400">No education added yet.</p>}
      </div>
      <AiPromptGenerator section="education" draft={draft} setDraft={setDraft} />
    </div>
  );
}
